import { render } from "./QuickResponseItem.vue?vue&type=template&id=472a4536&scoped=true&lang=pug"
import script from "./QuickResponseItem.vue?vue&type=script&lang=js"
export * from "./QuickResponseItem.vue?vue&type=script&lang=js"

import "./QuickResponseItem.vue?vue&type=style&index=0&id=472a4536&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-472a4536"]])

export default __exports__